import { isUndefined } from "es-toolkit";
import { Observable } from "rxjs";

export enum AnalyticsIncomeGroupByDataSourceType {
  BANK_ACCOUNT_DAILY = "bank-account-daily",
  BANK_ACCOUNT_MONTHLY = "bank-account-monthly",
  BANK_ACCOUNT_YEARLY = "bank-account-yearly",
  PAYMENT_METHOD_DAILY = "payment-method-daily",
  PAYMENT_METHOD_MONTHLY = "payment-method-monthly",
  PAYMENT_METHOD_YEARLY = "payment-method-yearly",
  CUSTOMER_TOP_10 = "customer-top-10",
  CUSTOMER_TOP_50 = "customer-top-50"
}

export enum AnalyticsSalesGroupByDataSourceType {
  PROFIT_CENTER_DAILY = "profit-center-daily",
  PROFIT_CENTER_MONTHLY = "profit-center-monthly",
  PROFIT_CENTER_YEARLY = "profit-center-yearly",
  SALES_DAILY = "sales-daily",
  SALES_MONTHLY = "sales-monthly",
  SALES_YEARLY = "sales-yearly",
  VAT_DAILY = "vat-daily",
  VAT_MONTHLY = "vat-monthly",
  VAT_YEARLY = "vat-yearly",
  MEMBER_DAILY = "member-daily",
  MEMBER_MONTHLY = "member-monthly",
  MEMBER_YEARLY = "member-yearly",
  CUSTOMER_TOP_10 = "customer-top-10",
  CUSTOMER_TOP_50 = "customer-top-50",
  PRODUCT_SALE_TOP_10 = "product-sale-top-10",
  PRODUCT_SALE_TOP_50 = "product-sale-top-50",
  PRODUCT_SALE_DAILY = "product-sale-daily",
  PRODUCT_SALE_MONTHLY = "product-sale-monthly",
  PRODUCT_SALE_YEARLY = "product-sale-yearly",
  MEDICAL_SERVICE_TOP_10 = "medical-service-top-10",
  MEDICAL_SERVICE_TOP_50 = "medical-service-top-50",
  MEDICAL_SERVICE_DAILY = "medical-service-daily",
  MEDICAL_SERVICE_MONTHLY = "medical-service-monthly",
  MEDICAL_SERVICE_YEARLY = "medical-service-yearly",
  MEDICAL_SERVICES_DAILY = "medical-services-daily",
  MEDICAL_SERVICES_MONTHLY = "medical-services-monthly",
  MEDICAL_SERVICES_YEARLY = "medical-services-yearly",
  DRUG_ASSIGNMENT_TOP_10 = "drug-assignment-top-10",
  DRUG_ASSIGNMENT_TOP_50 = "drug-assignment-top-50",
  DRUG_DAILY = "drug-daily",
  DRUG_MONTHLY = "drug-monthly",
  DRUG_YEARLY = "drug-yearly",
  VAT_RATEABLE_DAILY = "vat-rateable-daily",
  VAT_RATEABLE_MONTHLY = "vat-rateable-monthly",
  VAT_RATEABLE_YEARLY = "vat-rateable-yearly",
  NEW_CUSTOMER_DAILY = "new-customer-daily",
  NEW_CUSTOMER_MONTHLY = "new-customer-monthly",
  NEW_CUSTOMER_YEARLY = "new-customer-yearly",
  SPECIES_DAILY = "species-daily",
  SPECIES_MONTHLY = "species-monthly",
  SPECIES_YEARLY = "species-yearly",
  VAT_PAYMENT_METHOD_DAILY = "vat-payment-method-daily",
  VAT_PAYMENT_METHOD_MONTHLY = "vat-payment-method-monthly",
  VAT_PAYMENT_METHOD_YEARLY = "vat-payment-method-yearly",
  PAYMENT_METHOD_DAILY = "payment-method-daily",
  PAYMENT_METHOD_MONTHLY = "payment-method-monthly",
  PAYMENT_METHOD_YEARLY = "payment-method-yearly",
  RATE_TABLE_PROFIT_CENTER = "rate-table-profit-center",
  RATE_TABLE_DAILY = "rate-table-daily"
}

export type AnalyticsGroupByDataSourceType =
  | AnalyticsSalesGroupByDataSourceType
  | AnalyticsIncomeGroupByDataSourceType
  | AnalyticsCustomerGroupByDataSourceType
  | AnalyticsPatientsGroupByDataSourceType
  | AnalyticsTicketsGroupByDataSourceType;

export enum AnalyticsCustomerGroupByDataSourceType {
  CUSTOMER_NEW_DAILY = "customer-new-daily",
  CUSTOMER_NEW_MONTHLY = "customer-new-monthly",
  CUSTOMER_NEW_YEARLY = "customer-new-yearly",
  CUSTOMER_TYPE_NEW_DAILY = "customer-type-new-daily",
  CUSTOMER_TYPE_NEW_MONTHLY = "customer-type-new-monthly",
  CUSTOMER_TYPE_NEW_YEARLY = "customer-type-new-yearly",
  CUSTOMER_ACTIVE_DAILY = "customer-active-daily",
  CUSTOMER_ACTIVE_MONTHLY = "customer-active-monthly",
  CUSTOMER_ACTIVE_YEARLY = "customer-active-yearly"
}

export type AnalyticsStudiesGroupByDataSourceType =
  | "modality-daily"
  | "modality-monthly"
  | "modality-yearly"
  | "request-daily"
  | "request-monthly"
  | "request-yearly"
  | "date-daily"
  | "date-monthly"
  | "date-yearly"
  | "device-daily"
  | "device-monthly"
  | "device-yearly";

export enum AnalyticsPatientsGroupByDataSourceType {
  SPECIES_NEW_DAILY = "species-new-daily",
  SPECIES_NEW_MONTHLY = "species-new-monthly",
  SPECIES_NEW_YEARLY = "species-new-yearly",
  DECEASED_NEW_DAILY = "deceased-new-daily",
  DECEASED_NEW_MONTHLY = "deceased-new-monthly",
  DECEASED_NEW_YEARLY = "deceased-new-yearly",
  DATE_NEW_DAILY = "date-new-daily",
  DATE_NEW_MONTHLY = "date-new-monthly",
  DATE_NEW_YEARLY = "date-new-yearly"
}

export enum AnalyticsTicketsGroupByDataSourceType {
  SPECIES_DAILY = "species-daily",
  SPECIES_MONTHLY = "species-monthly",
  SPECIES_YEARLY = "species-yearly"
}

export enum AnalyticsGroupBy {
  PROFIT_CENTER = "profit-center",
  VAT = "vat",
  MEMBER = "member",
  RATE_TABLE = "rate-table",
  CUSTOMER = "customer",
  NEW_CUSTOMER = "new-customer",
  MEDICAL_SERVICE = "medical-service",
  SPECIES = "species",
  TOTALS = "totals",
  RATEABLE = "rateable",
  VAT_RATEABLE = "vat-rateable",
  PAYMENT_METHOD = "payment-method",
  BANK_ACCOUNT = "bank-account",
  CUSTOMER_ACTIVE = "customer-active",
  DATE = "date",
  TYPE = "type",
  DECEASED = "deceased"
}

export enum AnalyticsSalesRateTableType {
  PRODUCT_SALE = "product-sale",
  MEDICAL_SERVICE = "medical-service",
  DRUG_ASSIGNMENT = "drug-assignment",
  PAYMENT_METHOD = "payment-method"
}

export type AnalyticsCustomersGroupBy = "date" | "type" | "active";

export type AnalyticsPatientsGroupBy = "species" | "deceased" | "date" | "size";

export type AnalyticsTicketsGroupBy = "species";

export type AnalyticsIncomesGroupBy =
  | "bank-account"
  | "payment-method"
  | "customer"
  | "profit-center";

export type AnalyticsStudiesGroupBy =
  | "modality"
  | "request"
  | "date"
  | "device";

export enum AnalyticsGranularity {
  DAILY = "daily",
  MONTHLY = "monthly",
  YEARLY = "yearly"
}

export type AnalyticsIncome = {
  date: string;
  group: string;
  total: number;
  name?: string;
  count?: number;
};

export type AnalyticsSalesTotal = {
  rateable: number;
  vat: number;
  enpav: number;
};

export type AnalyticsSalesCustomerTotal = {
  total: number;
};

export type AnalyticsSales<T = AnalyticsSalesTotal> = {
  date: string | "unknown" | "drug";
  group: any;
  total: T;
  name?: string;
  count?: number;
  valueType: string;
  average?: number;
};

export type AnalyticsCustomers = {
  date: string;
  group: string;
  total: number;
  name?: string;
  count?: number;
};

export type AnalyticsPatients = {
  date: string;
  group: string;
  total: number;
  name?: string;
  count?: number;
};

export type AnalyticsTickets = {
  date: string;
  group: string;
  total: number;
  name?: string;
  count?: number;
};

export type AnalyticsStudies = {
  date: string;
  group: string;
  total: number;
  name?: string;
  count?: number;
};

export type AnalyticsItem =
  | AnalyticsIncome
  | AnalyticsSales
  | AnalyticsCustomers
  | AnalyticsPatients
  | AnalyticsTickets;

export type AnalyticsItemWithoutSales = Exclude<AnalyticsItem, AnalyticsSales>;

export type AnalyticsKpi = {
  date: string;
  average: number;
};

export type AnalyticsSurveys = {};

export type AnalyticsResponse<T> = {
  count: number;
  total: number;
  totalAverage: number;
  items: T[];
};

export type AnalyticsResponseValue = {
  current: number;
  previous: number;
  change: number;
};

export enum AnalyticsKpiValueFormat {
  MONEY = "money",
  PERCENTAGE = "percentage",
  DURATION_MINUTES = "duration-minutes",
  NUMBER = "number"
}
